<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="0" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model="keyword" placeholder="请输入素材名称/素材ID" style="width: 190px" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem>
          <game-modal v-model="gameId" :game-data="gameData" :width="192" placeholder="选择游戏" />
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="designId" multiple collapse-tags filterable placeholder="选择设计师">
            <el-option v-for="label in designerData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="scheId" multiple collapse-tags filterable placeholder="选择策划师">
            <el-option v-for="label in schemeData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="labelId" style="width: 180px" multiple collapse-tags filterable clearable placeholder="选择内容标签">
            <el-option v-for="label in labelList.contentLabels" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="bigId" style="width: 180px" multiple collapse-tags filterable clearable placeholder="选择营销主题标签">
            <el-option v-for="label in labelList.marketingLabels" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem v-show="false">
          <el-select v-model="countrId" multiple collapse-tags filterable placeholder="选择国家">
            <el-option v-for="label in counties" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="mediaId" multiple collapse-tags filterable placeholder="选择媒体" style="width: 155px" @change="handleMedia">
            <el-option v-for="label in mediaData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem v-show="false">
          <el-select v-model="advertPositionId" multiple collapse-tags filterable placeholder="选择流量位">
            <el-option v-for="label in advertPositionData" :key="label.key" :value="label.key" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem v-show="false">
          <el-select v-model="platform" multiple collapse-tags filterable placeholder="选择平台" style="width: 120px">
            <el-option v-for="label in platformData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="accountId" style="width: 180px" multiple collapse-tags filterable placeholder="选择账号">
            <el-option v-for="label in accountData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="typeId" multiple collapse-tags filterable placeholder="选择素材类型" style="width: 126px">
            <el-option v-for="label in materialData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="opId" multiple collapse-tags filterable placeholder="选择管理人员">
            <el-option v-for="label in operatorData" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <DateRangePicker v-model="datetime" style="width: 220px"></DateRangePicker>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="sendEvent">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { trim, isArray } from '@/common/js/utils'
import DateRangePicker from '@/components/date-range-picker'
import GameModal from '@/components/gamemodal'
import { LABEL_TYPES } from '@/views/material/tags/const'
const advertPosiNames = [
  { id: 96, name: 'Audience network', key: 'PLACEMENT_AUDIENCE_NETWORK' },
  { id: 96, name: 'News feed', key: 'PLACEMENT_NEWS_FEED' },
  { id: 96, name: 'Instagram', key: 'PLACEMENT_INSTAGRAM' },
  { id: 96, name: 'Messenger', key: 'PLACEMENT_MESSENGER' },
  { id: 181, name: 'TikTok', key: 'PLACEMENT_TIKTOK' },
  { id: 181, name: 'News feed app seties', key: 'PLACEMENT_NEWS_FEED_APP_SETIES' },
  { id: 181, name: 'Pangle', key: 'PLACEMENT_PANGLE' }
]
export default {
  name: 'OverseasFilter',
  components: { GameModal, DateRangePicker },
  props: {
    gameData: {
      type: Array
    },
    operatorData: {
      type: Array
    },
    designerData: {
      type: Array
    },
    schemeData: {
      type: Array
    },
    accountData: {
      type: Array
    },
    tagData: {
      type: Array
    },
    counties: {
      type: Array
    },
    materialData: {
      type: Array
    }
  },
  computed: {
    advertPositionData() {
      if (isArray(this.mediaId) && this.mediaId.length) return advertPosiNames.filter((ret) => this.mediaId.includes(ret.id))
      else return []
    },
    labelList() {
      return {
        contentLabels: this.tagData.filter((i) => i.labelType === LABEL_TYPES.CONTENT_LABEL),
        threeDLabels: this.tagData.filter((i) => i.labelType === LABEL_TYPES.THREED_LABEL),
        marketingLabels: this.tagData.filter((i) => i.labelType === LABEL_TYPES.MARKETING_LABEL)
      }
    }
  },
  data() {
    return {
      datetime: [],
      designId: [],
      scheId: [],
      opId: [],
      labelId: [],
      bigId: [],
      accountId: [],
      gameId: [],
      typeId: [],
      keyword: '',
      platform: [],
      mediaId: [],
      countrId: [],
      advertPositionId: [],
      platformData: [
        { id: 1, name: 'Andriod' },
        { id: 2, name: 'iOS' }
      ],
      mediaData: [
        { id: 96, name: 'Facebook' },
        { id: 159, name: 'Google' },
        { id: 181, name: 'Tiktok' }
      ]
    }
  },
  methods: {
    sendEvent() {
      const [begin, end] = this.datetime
      const labelIds = [this.bigId, this.labelId].filter((i) => Array.isArray(i)).flat()
      let params = {
        platformStr: isArray(this.platform) && this.platform.length ? this.platform.join(',') : undefined,
        mediaIdStr: isArray(this.mediaId) && this.mediaId.length ? this.mediaId.join(',') : undefined,
        siteSetStr: isArray(this.advertPositionId) && this.advertPositionId.length ? this.advertPositionId.join(',') : undefined,
        imgTypesStr: isArray(this.typeId) && this.typeId.length ? this.typeId.join(',') : undefined,
        gameIdStr: isArray(this.gameId) && this.gameId.length ? this.gameId.join(',') : undefined,
        adAccountIdStr: isArray(this.accountId) && this.accountId.length ? this.accountId.join(',') : undefined,
        labelIdsStr: labelIds?.length.join(',') || undefined,
        opIdsStr: isArray(this.opId) && this.opId.length ? this.opId.join(',') : undefined,
        plannerIdStr: isArray(this.scheId) && this.scheId.length ? this.scheId.join(',') : undefined,
        designerIdStr: isArray(this.designId) && this.designId.length ? this.designId.join(',') : undefined,
        countrysStr: isArray(this.countrId) && this.countrId.length ? this.countrId.join(',') : undefined,
        keyword: trim(this.keyword)
      }
      if (begin && end) params = Object.assign({}, params, { uploadBeginTime: begin, uploadEndTime: end })
      this.$emit('on-change', params)
    },
    handleMedia(val) {
      this.advertPositionId = advertPosiNames
        .filter((met) => val.includes(met.id) && this.advertPositionId.includes(met.key))
        .map((met) => met.key)
    }
  }
}
</script>
<style lang="scss" scoped></style>
